var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner"},[_c('div',{staticClass:"bottom-wrap"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$theme ? '合作伙伴' : 'PARTNERS'))]),_c('img',{staticClass:"line",attrs:{"src":require("@/assets/img/brand-honor/partner/line.png"),"alt":""}}),_c('vue-seamless-scroll',{staticClass:"top",attrs:{"data":[1,2,3, 4, 5],"classOption":{
      step: 3,
      autoPlay: true,
      hoverStop: false,
      direction: _vm.direction
    }}},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":require("@/assets/img/brand-honor/partner/top.png"),"alt":""}})])]),_c('vue-seamless-scroll',{staticClass:"bottom",attrs:{"data":[1,2,3, 4, 5],"classOption":{
      step: 3,
      autoPlay: true,
      hoverStop: false,
      direction: _vm.direction
    }}},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":require("@/assets/img/brand-honor/partner/bottom.png"),"alt":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }